import { FC, SVGProps } from 'react';

const MediaViewerZoomInIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M16.7075 9.51425C16.7075 5.64022 13.5673 2.5 9.69329 2.5C5.81931 2.5 2.67908 5.64022 2.67908 9.51425C2.67908 13.3882 5.81931 16.5292 9.69329 16.5292C13.5673 16.5292 16.7075 13.3882 16.7075 9.51425Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.4678 14.6533L17.321 17.5"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.83362 9.51459H11.5195"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.67688 7.67171V11.3576"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MediaViewerZoomInIcon;
